import { render } from "./MaintainPage.vue?vue&type=template&id=132d39db"
import script from "./MaintainPage.vue?vue&type=script&lang=js"
export * from "./MaintainPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__